(() => {
  const init = (root) => {
    if (!root || root.dataset.k2CmegaReady === 'true') return;
    root.dataset.k2CmegaReady = 'true';
    const tabs = [...root.querySelectorAll('[data-k2-cmega-tab]')];
    const panels = [...root.querySelectorAll('[data-k2-cmega-panel]')];
    const activate = (id) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.k2CmegaTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.k2CmegaPanel === id;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => activate(tab.dataset.k2CmegaTab));
      tab.addEventListener('focus', () => activate(tab.dataset.k2CmegaTab));
    });
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-k2-cmega]').forEach(init);
  const initMobile = (root) => {
    if (!root || root.dataset.k2MobileCmegaReady === 'true') return;
    root.dataset.k2MobileCmegaReady = 'true';
    const categories = root.querySelector('[data-k2-mm-category-view]');
    const productView = root.querySelector('[data-k2-mm-product-view]');
    const productPanels = [...root.querySelectorAll('[data-k2-mm-products]')];
    const reset = () => {
      categories.hidden = false;
      productView.hidden = true;
      productPanels.forEach((panel) => panel.hidden = true);
    };
    root.querySelectorAll('[data-k2-mm-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = root.querySelector(`[data-k2-mm-products="${button.dataset.k2MmOpen}"]`);
        categories.hidden = true;
        productView.hidden = false;
        productPanels.forEach((item) => item.hidden = item !== panel);
        root.closest('[data-drawer-scrolls]')?.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    root.querySelector('[data-k2-mm-back]')?.addEventListener('click', reset);
    root.k2MobileReset = reset;
  };
  const initAllMobile = (scope = document) => scope.querySelectorAll('[data-k2-mobile-cmega]').forEach(initMobile);
  const start = () => { initAll(); initAllMobile(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  document.addEventListener('shopify:section:load', (event) => { initAll(event.target); initAllMobile(event.target); });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sliderule-close], [data-drawer-toggle="hamburger"]')) {
      document.querySelectorAll('[data-k2-mobile-cmega]').forEach((root) => root.k2MobileReset?.());
    }
  });
})();
